<ng-template #defaultHeader>
    <div class="b-sidebar__title">
        <div [class.b-sidebar__title--is-collapsed]="isCollapsed" (click)="toggle()">
            <span class="b-sidebar__title-icon"></span>
            <span class="b-sidebar__title-name" [innerHTML]="titleAsync | async"></span>
        </div>
        <div>
            <span class="b-sidebar__title-option" *ngIf="!isCollapsed && !showPopup">
                <ng-content select="f-facet[name=sidebar-option],[facet-sidebar-option]"></ng-content>
            </span>
        </div>
    </div>
</ng-template>
<ng-template #tabbedHeaderCollapsed><button w-button (click)="isCollapsed=false">{{titleAsync |
        async}}</button></ng-template>
<ng-template #tabbedHeader>
    <div>
        <button w-button buttonType="tertiary" (click)="wTabCancel.emit()">{{tabCancelAsync | async}}</button>
    </div>
    <div class="b-sidebar__tabbed-title" [innerHTML]="titleAsync | async"></div>
    <div>
        <button w-button buttonType="tertiary" (click)="wTabApply.emit()">{{tabApplyAsync | async}}</button>
    </div>
</ng-template>
<div class="b-sidebar" [class.b-sidebar__tabbed]="showTabbed" [class.b-sidebar--sticky]="stateSticky | async" [style.min-height.px]="stateBarHeight | async"
    [class.b-sidebar__tabbed-popup]="showTabbed &&!isCollapsed">
    <div #wrapper class="b-sidebar__filters-wrapper" [class.b-sidebar--is-collapsed]="isCollapsed" 
        [style.top.px]="stickyTop" 
        [style.zIndex]="maxZIndex">
        <header class="b-sidebar__heading" [class.b-sidebar__tabbed-header]="showTabbed && !isCollapsed">
            <ng-container
                *ngTemplateOutlet="showTabbed ? (isCollapsed ? tabbedHeaderCollapsed : tabbedHeader) : defaultHeader"></ng-container>
        </header>

        <div class="b-flex-row">
            <div *ngIf="showTabs && tabs.length>1" class="b-sidebar__tabs">
                <div class="b-sidebar__button" [class.b-sidebar__button-active]="i === selectedTab"
                    *ngFor="let t of tabs; let i = index" (click)="showTab(t, i)">
                    <span [innerHTML]="t.labelAsync | async"></span>
                </div>
            </div>
            <div class="b-sidebar__sections" *ngIf="!isCollapsed">
                <div class="b-sidebar__content-wrapper" *ngIf="!showPopup">
                    <ng-content select="f-facet[name=sections],[facet-sections]"></ng-content>
                </div>
                <div class="b-sidebar__content-wrapper" *ngIf="showPopup">
                    <ng-content select="f-facet[name=popup],[facet-popup]"></ng-content>
                </div>
            </div>
        </div>
        <div class="b-flex-grow" #space></div>
    </div>
    <div #content class="b-sidebar__content">
        <div><ng-content></ng-content></div>
        <div class="b-flex-grow" #contentSpace></div>
    </div>
</div>